import * as React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { BranchData } from 'src/reducers/fileUpload';
import MaterialTable, { Column } from 'material-table';
import EditIcon from '@material-ui/icons/Edit';

interface TableState {
    columns: Array<Column<BranchData>>;
    data: BranchData[];
}

export interface DesignPreferencePageViewProps {
    orderDataBranch: BranchData[];
    goEditDesignPreference: (sbu: string) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center'
            // height: 'calc(90vh - 64px)'
        },
    })
);

const DesignPreferencePageView: React.StatelessComponent<DesignPreferencePageViewProps> = props => {
    const classes = useStyles({});
    const [state] = React.useState<TableState>({
        columns: [
            {
                title: 'Name',
                field: 'sbu_name',
                cellStyle: {
                    width: '500px',
                    minWidth: '500px'
                },
            },
        ],
        data: props.orderDataBranch
    });
    return (
        <div className={classes.root}>
            <MaterialTable
                title="Business Units"
                columns={state.columns}
                data={props.orderDataBranch}
                localization={{
                    header: {
                        actions: 'Edit'
                    },
                }}
                options={{
                    sorting: true,
                    actionsColumnIndex: -1,
                    headerStyle: {
                        backgroundColor: '#757575',
                        color: '#fff'
                    },
                    search: false,
                    paging: false
                }}
                actions={[
                    {
                        icon: () => (
                            <EditIcon
                                color="primary"
                            />),
                        tooltip: 'Edit',
                        onClick: (event, rowData: BranchData) => {
                            props.goEditDesignPreference(rowData.sbu_name);
                        }
                    },
                    // {
                    //     icon: 'chevron_right',
                    //     tooltip: 'view',
                    //     onClick: (event, rowData) => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))
                    // }
                ]}
            />
        </div>
    );
};

export default DesignPreferencePageView;



// WEBPACK FOOTER //
// ./src/components/layouts/DesignPreferencePageView.tsx